export default "__VITE_ASSET__D9QSj9n1__"